<template>

  <div
    v-if="error"
    class="alert alert-danger">
    {{ error['message'] }}
  </div>

</template>

<script>
export default {
  name: 'ValidateMessage',
  props: [
    'error'
  ],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
